import { RegistrationFooterContent } from "../registrationFooter/utils";
import { IBaseDisplayBehaviour } from "./IBaseDisplayBehaviour";

export class IframeDisplayBehaviour implements IBaseDisplayBehaviour {
  getRegistrationFooterContentList({ displayPoweredBy }: { displayPoweredBy?: boolean }): RegistrationFooterContent[] {
    const contentList: RegistrationFooterContent[] = [];
    if (displayPoweredBy) {
      contentList.push(RegistrationFooterContent.POWERED_BY);
    }
    return contentList;
  }
  canShowRegistrationHeader(): boolean {
    return false;
  }
  canShowTicketPageDescriptionInRegistration(searchParams: URLSearchParams): boolean {
    // todo: rd add params in IFrameQueryParams
    if (searchParams.get("description")) {
      return searchParams.get("description") !== "false";
    }
    return true;
  }
  canShowTicketPageImageInRegistration(searchParams: URLSearchParams): boolean {
    // todo: rd add params in IFrameQueryParams
    if (searchParams.get("image")) {
      return searchParams.get("image") !== "false";
    }
    return true;
  }
}
